<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>保险到期提醒</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <!-- <el-row :gutter="20">
        <el-col :span="9">
          <el-form
              :inline="true"
              :model="searchForm"
              :rules="searchRules"
              ref="searchForRef"
              label-width="80px"
              autocomplete="on"
            >
            <el-form-item label="保司名称" prop="name" size="small">
              <el-input v-model="searchForm.name" clearable type="text"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
          <el-col :span="1">
            <el-button type="success" size="small" @click="searchSubmit()">搜索</el-button>
          </el-col>
          <el-col :span="1" :offset="1">
            <el-button type="primary" size="small" @click="addData">新增</el-button>
          </el-col>
        </el-row> -->

        <!-- 表格 -->
        <e-table :tableHeadConfig="tableHeadConfig" :tableLoadData="tableLoadData" style="margin-top:20px">
          <template v-slot:Title="slotData">
              <span class="table_name" @click="handelDetail(slotData)">{{ slotData.data.row.title }}</span>
          </template>
          <template v-slot:operation="slotData">
            <el-button type="warning" size="mini" @click="handelEdit(slotData)"> 编辑{{slotData.data.row.level}}</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="handelDel(slotData)">{{slotData.data.row.level}}</el-button>
          </template>
        
        </e-table>
        <!-- 分页 -->
        <div class="block" style="margin-top:10px">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[20, 30, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
          </el-pagination>
        </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">

        <el-form-item label="保司名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入保司名称"></el-input>
        </el-form-item>
        
    
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment'     //日期时间转换

export default {
  name: "adminStaff",
  components: {
    eTable
  },
  props: {},
  data() {
    return {
      // 搜索
      searchForm: {
        name: "",
      },
      searchRules: {
        name: [
          { required: true, message: "请输入保司名称", trigger: "blur" }
        ],
      },
      // 表头
      tableHeadConfig: [
        {
          label: "Id",
          width: "150px",
          field: "showType"
        },
        {
          label: "到期提醒",
          columnType: "slot",
          slotName: "Title",

        },
        // {
        //   label: "操作",
        //   columnType: "slot",
        //   slotName: "operation",
        //   width: 260
        // }
      ],
      // 数据
      tableLoadData: [],
      pageNum:1,// 当前页码
      pageSize:10,// 每页大小
      total:0,//总条目数
      id: '',

      roleList: [],

      rules: {
        name: [
          { required: true, message: '请输入保司名称', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 15 个字符",
            trigger: "blur",
          }
        ],

      },

      dialogFormVisible: false,
      title: '',
      form: {
        name: '',
      },
    
    };
  },
  created() {
    this.DataList()
    this.departData()
  },
  mounted() {
    
  },
    filters: {
    /**
     * @param {
     *     
     * }
     */
       //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },

  },
  methods: {
    DataList(){
      const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          // page: this.pageNum,
          // pageSize: this.pageSize,
      }
      this.$axios.shopRemind(param).then(res=>{
        if(res.code == 200){
          //console.log(res.data,2233);
          this.tableLoadData = res.data
          this.total = res.data.length
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    departData(){
      const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
      }
      this.$axios.findTree(param).then(res=>{
        if(res.code == 200){
          this.rightslist = res.data.data
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
  
    // 新增
    addData() {
      this.title = '新增'
      this.form = {
        name: '',
      }
      this.dialogFormVisible = true
    },
    handelEdit(index,row) {
      this.id = index.data.row.id
      this.title = '编辑'
      this.form = {
        name: this.name,
      }
      this.dialogFormVisible = true
      // this.form = {...row};
      // 或者
      this.form = JSON.parse(JSON.stringify(index.data.row))
    },

    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.id){
            const param = {
              name: this.form.name,
              operator_id: sessionStorage.getItem('user_id'),
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token'),
            }
            this.$axios.insuranceCorpSave(param).then(res =>{
                //console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                    this.$message.error(res.msg);
                }
              })
            }else{
            const param = {
              id: this.form.id,
              name: this.form.name,
              operator_id: sessionStorage.getItem('user_id'),
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
            }
            this.$axios.insuranceCorpSave(param).then(res =>{
              if(res.code == 200){
                this.$message.success(res.msg)
                this.DataList()
                this.dialogFormVisible = false
              }else{
                  this.$message.error(res.msg);
              }
            })
          }
          
        }
      })
    },
    // searchSubmit() {
    //   const param = {
    //       queryParams: this.searchForm.name,
    //       company_id:sessionStorage.getItem('company_id'),
    //       access_token:sessionStorage.getItem('token'),
    //       page: this.pageNum,
    //       pageSize: this.pageSize
    //   }
    //   this.$refs.searchForRef.validate((valid) => {
    //     if (valid) {
    //       this.$axios.insuranceCorpList(param).then(res=>{
    //         if(res.code == 200){
    //           this.tableLoadData = res.data.data
    //           this.total = res.data.total
    //         }
    //       })
    //     }
    //   })
    // },

    handelDel(e) {
        //console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          id: e.data.row.id,    
        }
        this.$axios.insuranceCorpDel(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      }).catch(() => {
          // 点击取消:不删除了
          this.$message({
              type: 'info',
              message: '已取消删除'
          });
          this.DataList()
      });    
      this.teamDialog = false
    },
    handelDetail(index,row) {
      this.$router.push({
          path: '/shopRemindList',
          query: {
            showType: index.data.row.showType
          }
      });
    },

  },
};
</script>
<style lang="less">
  .table_name{
    font-weight: bold;
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
  .upload-demo{
    margin-left: 60px;
    margin-bottom: 20px;  
  }
</style>


// WEBPACK FOOTER //
// src/view/shipCompany/shopRemind.vue